export default [{
  path: '/vacation-plane',
  name: 'vacationPlane',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/vacationPlane/index')
}]
